export const invitationActionTypes = {
    INVITATION_VERIFY_REQUEST: 'I1',
    INVITATION_VERIFY_SUCCESS: 'I2',
    INVITATION_VERIFY_FAILURE: 'I3',

    INVITATION_ACCEPT_REQUEST: 'I4',
    INVITATION_ACCEPT_SUCCESS: 'I5',
    INVITATION_ACCEPT_FAILURE: 'I6',

    INVITATION_RESET: 'I7',
};
